module.exports = __webpack_public_path__ + "img/pushowl_logo.3281519b.svg";